import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

import { ProfileWorkBefore } from "core/http/service/operationProcess/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: ProfileWorkBefore[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getProfileWorkBeforeSlice = createSlice({
  name: "getComments",
  initialState,
  reducers: {
    getProfileWorkBeforeStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getProfileWorkBeforeSuccess: (
      state,
      action: PayloadAction<ProfileWorkBefore[]>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getProfileWorkBeforeFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetProfileWorkBefore: () => {
      return { ...initialState };
    },
  },
});

export const {
  getProfileWorkBeforeStart,
  getProfileWorkBeforeSuccess,
  getProfileWorkBeforeFailed,
  resetProfileWorkBefore,
} = getProfileWorkBeforeSlice.actions;

export default getProfileWorkBeforeSlice.reducer;
